import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Redirect, Link } from "react-router-dom";
import { Divider, TextField } from "@material-ui/core";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Radio from "@material-ui/core/Radio";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

//importing files
import confirm from "../../assets/images/order/confirm.jpg";
import { useCartContext } from "../../context/CartContext";
import { useUserContext } from "../../context/UserContext";
import api from "../../Axios/api";
import logo from "../../assets/images/logo.png";
import StripeCheckout from "react-stripe-checkout";

//impoting icons
import ReceiptIcon from "@material-ui/icons/Receipt";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import GetAppIcon from "@material-ui/icons/GetApp";
import LocalMallIcon from "@material-ui/icons/LocalMall";

// MUI Components
import { Grid, Button, Typography } from "@material-ui/core";

export default function Checkout() {
  const classes = useStyles();
  const { cartProducts } = useCartContext();
  const { store } = useUserContext();
  let user = "";
  let token = "";
  if (store) {
    token = store.data.token;
    user = store;
  }
  const [cardCharge, setCardCharge] = useState(null);
  const [checkoutProducts, setCheckoutProducts] = useState([]);
  const [shippingFee, setShippingFee] = useState(0);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = ["Delivery Address", "Payment", "Order Placed"];
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    React.useState("cash");
  const [voucherDiscount, setVoucherDiscount] = useState(0);
  const [orderResponse, setOrderResponse] = useState([]);
  const cities = [
    "Rawalpindi",
    "Islamabad",
    "Faisalabad",
    "Lahore",
    "Gujranwala",
  ];
  const [paymentReceiptURL, setPaymentReceiptURL] = useState(null);
  const STRIPE_KEY =
    "pk_test_51JxX22SD2TonFhJ3PRyA2XmA9KpKuTdaqkAg48q6jXXGOCOWxsUr7kPT0vybSDvzATWCXmCJmG0qMJ00p8eEEnD2004le4oDS1";

  //for delivery address
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [deliveryInstructions, setDeliveryInstructions] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");

  const [IFerrors, setIFerrors] = useState({
    nameError: "",
    emailError: "",
    phoneNumberError: "",
    deliveryInstructionsError: "",
    cityError: "",
    addressError: "",
  });

  //for delivery address
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };
  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    if (cartProducts != "null" && cartProducts != null) {
      let checkoutItems = cartProducts;
      let sumOfShippingCost = 0;
      let totalPriceOfAllItems = 0;
      let totalItemsQuantity = 0;
      setCheckoutProducts(checkoutItems);
      checkoutItems.forEach((item) => {
        sumOfShippingCost = sumOfShippingCost + item.shippingCost;
        totalPriceOfAllItems =
          totalPriceOfAllItems + item.price * item.quantity;
        totalItemsQuantity = totalItemsQuantity + item.quantity;
      });
      //add dicount of voucher code if applied before while adding in cart
      let tempDiscount = 0;
      cartProducts.forEach((item) => {
        if (item.voucherDiscount) {
          tempDiscount += item.voucherDiscount;
        }
      });
      setVoucherDiscount(tempDiscount);
      setShippingFee(sumOfShippingCost);
      setSubTotal(totalPriceOfAllItems);
      setTotal(
        Math.round(sumOfShippingCost + totalPriceOfAllItems - tempDiscount)
      );
      setTotalQuantity(totalItemsQuantity);
      if (user.data) {
        user = user.data.data;
        setName(user.name ? user.name : "");
        setPhoneNumber(user.phoneNumber ? user.phoneNumber : "");
        setEmail(user.email ? user.email : "");
        setAddress(user.address ? user.address : "");
        setCity(user.city ? user.city : "");
      }
    }
  }, []);
  const get7DaysAboveDate = () => {
    var ms = new Date().getTime() + 7 * 86400000;
    var newDate = new Date(ms);
    return newDate.toISOString().split("T")[0];
  };

  const getExpectedDeliveryDate = () => {
    var ms = new Date().getTime() + 7 * 86400000;
    var newDate = new Date(ms);
    return newDate.toISOString();
  };

  const downloadReceipt = () => {
    html2canvas(document.querySelector("#OrderReceiptBox")).then((canvas) => {
      document.body.appendChild(canvas); // if you want see your screenshot in body.
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      var width = pdf.internal.pageSize.getWidth();
      var height = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, "PNG", 0, 0, width, height);
      pdf.save(`MyOrder.pdf`);
    });
  };

  const handlePlaceOrder = (cardCharge) => {
    //scroll to the top of page
    let tempPaymentMethod = "cash";
    window.scrollTo(0, 0);
    if (cardCharge) {
      setPaymentReceiptURL(cardCharge.receipt_url);
      setSelectedPaymentMethod("card");
      tempPaymentMethod = "card";
    }
    const storeNamesOfAllProducts = [];
    const productsOfEachStore = [];
    //getting storenames of which to place order
    checkoutProducts.forEach((product) => {
      if (!storeNamesOfAllProducts.includes(product.storeName)) {
        storeNamesOfAllProducts.push(product.storeName);
      }
    });
    //adding all products seperately in productsOfEachStore array so
    //that place order seperately to each store's own products not other store products
    let isStoreAlreadyPresent = false;
    storeNamesOfAllProducts.forEach((storeName) => {
      checkoutProducts.forEach((product) => {
        isStoreAlreadyPresent = false;
        if (product.storeName === storeName) {
          if (productsOfEachStore.length > 0) {
            productsOfEachStore.forEach((item) => {
              //if already present store product in productsOfEachStore array
              if (item.storeName === product.storeName) {
                item.products.push(product);
                isStoreAlreadyPresent = true;
                return;
              }
            });
            //if not already present then
            if (!isStoreAlreadyPresent) {
              productsOfEachStore.push({
                storeName: storeName,
                products: [product],
              });
            }
          } else {
            productsOfEachStore.push({
              storeName: storeName,
              products: [product],
            });
          }
        }
      });
    });
    // console.log("stores", storeNamesOfAllProducts);
    // console.log("products", productsOfEachStore);

    //placing order seperately on each store
    productsOfEachStore.forEach((obj) => {
      const orderedProducts = [];
      let productsTotal = 0;
      let productsSubtotal = 0;
      let productsShippingFee = 0;
      let productsQuantity = 0;
      let productsTotalDiscount = 0;
      if (obj.products) {
        obj.products.forEach((product) => {
          let myProduct = {
            productId: product._id,
            name: product.title,
            salePrice: product.price,
            discount: product.discountPercentage,
            discountedPrice: product.voucherDiscount,
            voucherCode: product.voucherCode,
            quantity: product.quantity,
            color: product.color ? product.color : null,
          };
          if (!myProduct.color) {
            delete myProduct.color;
          }
          orderedProducts.push(myProduct);
          productsSubtotal =
            productsSubtotal + product.price * product.quantity;
          productsShippingFee = productsShippingFee + product.shippingCost;
          productsTotal = productsSubtotal + productsShippingFee;
          productsQuantity += product.quantity;
          productsTotalDiscount += product.voucherDiscount
            ? product.voucherDiscount
            : 0;
        });
      }
      const orderData = {
        products: orderedProducts,
        name,
        deliveryAddress: address,
        deliveryDate: getExpectedDeliveryDate(),
        contactNumber: phoneNumber,
        email,
        couponCode: null,
        subTotalPrice: productsSubtotal,
        totalPrice: productsTotal,
        shippingFee: productsShippingFee,
        deliveryInstructions: deliveryInstructions,
        totalQuantity: productsQuantity,
        paymentMethod: tempPaymentMethod,
        city: city,
        totalDiscount: productsTotalDiscount,
        cardPaymentDetails: cardCharge
          ? {
              currency: cardCharge.currency,
              transactionId: cardCharge.id,
              stripeCustomerId: cardCharge.customer,
              status: cardCharge.status,
              senderEmail: cardCharge.source.name,
              receipt_url: cardCharge.receipt_url,
            }
          : null,
      };
      api
        .post(
          "/buyer/product/order",
          {
            ...orderData,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          let order = res.data.data.order;
          setOrderResponse((oldValue) => [...oldValue, order]);
        })
        .catch((error) =>
          error.response
            ? setSnackBar({
                ...snackBarstate,
                message: "Cannot place order at this time! Please try later",
                type: "error",
                open: true,
              })
            : null
        );
    });
    //clear cart and reload page
    localStorage.removeItem("CART_DATA");
    //go to next tab
    handleNext();
  };

  const InputValidation = () => {
    const errors = {};
    var hasError = false;

    // name
    var noNumber = /^([^0-9]*)$/;
    if (name.match(noNumber)) {
      errors.nameError = "";
    } else {
      hasError = true;
      errors.nameError = "Name cannot contains Numbers or Special Characters!";
    }

    // email
    // eslint-disable-next-line
    var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email.match(mailFormat)) {
      errors.emailError = "";
    } else {
      hasError = true;
      errors.emailError = "Entered Email address is invalid!";
    }

    // phone
    var phoneFormat = /^(\+92)?[0-9]{10}$/;
    if (phoneNumber.match(phoneFormat)) {
      errors.phoneNumberError = "";
    } else {
      hasError = true;
      errors.phoneNumberError = "Entered Phone Number is invalid!";
    }

    // city
    var cityFormat = /^([^0-9]*)$/;
    if (city.match(cityFormat) && city != "") {
      errors.cityError = "";
    } else {
      hasError = true;
      if (city == "") {
        errors.cityError = "please enter your city here.";
      }
      if (!city.match(cityFormat))
        errors.cityError =
          "City cannot contains Numbers or Special Characters!";
    }

    // address
    var addressFormat = /^[a-zA-Z0-9-@#{1},\s]*$/;
    if (address.match(addressFormat) && address.length > 10) {
      errors.addressError = "";
    } else {
      hasError = true;
      if (address.length <= 10) {
        errors.addressError =
          "Address is too short. Please enter detailed address.";
      }
      if (!address.match(addressFormat)) {
        errors.addressError =
          "Entered Address is invalid. Special Characters not allowed i.e. /!$%^&*()";
      }
    }

    setIFerrors({ ...IFerrors, ...errors });
    return hasError;
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return getDeliveryAddressDetails();
      case 1:
        return getPaymentDetails();
      case 2:
        return orderConfirmationBox();
      default:
        return "Unknown step";
    }
  }

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleGoToPaymentPage = () => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    var errorExists = InputValidation();
    if (!errorExists) handleNext();
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleChangeSelectedPayment = (event) => {
    setSelectedPaymentMethod(event.target.value);
  };

  const getDeliveryAddressDetails = () => {
    return (
      <Grid container>
        <Grid lg={7} className={classes.StepperPage}>
          <Typography
            variant="h5"
            style={{ fontWeight: "bold", marginBottom: 10 }}
          >
            Enter Delivery Instructions
          </Typography>
          <Typography variant="p" style={{ color: "#666" }}>
            The selected address will be used both as your personal address (for
            invoice) and as your delivery address.
          </Typography>

          <Grid container>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                label="Name"
                autoComplete="name"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
                helperText={IFerrors.nameError}
                error={IFerrors.nameError.length > 0 ? true : false}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                label="Email"
                autoComplete="email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                helperText={IFerrors.emailError}
                error={IFerrors.emailError.length > 0 ? true : false}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                label="Phone Number"
                fullWidth
                placeholder="+923XXXXXXXXX"
                inputProps={{ maxLength: 13 }}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                helperText={IFerrors.phoneNumberError}
                error={IFerrors.phoneNumberError.length > 0 ? true : false}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl variant="outlined" style={{ width: "100% " }}>
                <InputLabel id="demo-simple-select-outlined-label">
                  City
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  label="City"
                  helperText={IFerrors.cityError}
                  error={IFerrors.cityError.length > 0 ? true : false}
                >
                  <MenuItem value="" disabled>
                    <em>None</em>
                  </MenuItem>
                  {cities.map((city) => {
                    return <MenuItem value={city}>{city}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                label="Address"
                fullWidth
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                helperText={IFerrors.addressError}
                error={IFerrors.addressError.length > 0 ? true : false}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                type="text"
                label="Delivery Instructions (optional)"
                fullWidth
                multiline
                rows={4}
                value={deliveryInstructions}
                onChange={(e) => setDeliveryInstructions(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} className={classes.buttons}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Link to="/cart" style={{ textDecoration: "none" }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      fullWidth
                      // onClick={() => (window.location.href = "/cart")}
                    >
                      Back
                    </Button>
                  </Link>
                </Grid>
                <Grid item xs={9}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGoToPaymentPage}
                    fullWidth
                  >
                    Continue To Payment
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Summary box */}
        {orderSummaryBox()}
      </Grid>
    );
  };

  function orderSummaryBox(tab) {
    return (
      <Grid lg={5} sm={12} style={{ width: "100%" }}>
        <div className={classes.checkoutBoxMianDiv}>
          <div className={classes.checkoutTitleBox}>
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                letterSpacing: 1,
                wordSpacing: 4,
              }}
            >
              ORDER SUMMARY
            </Typography>
          </div>

          <div className={classes.mainCheckoutBox}>
            {tab !== "Payment" ? (
              !checkoutProducts ? null : (
                checkoutProducts.map((item) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 10,
                      }}
                      key={item._id}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          maxWidth: 300,
                        }}
                      >
                        {/* <img
                          className={classes.checkoutProductImg}
                          src={item.image}
                        ></img> */}
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Typography
                            noWrap
                            variant="p"
                            style={{ maxWidth: 150 }}
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            noWrap
                            variant="p"
                            style={{
                              maxWidth: 150,
                              color: "grey",
                              fontSize: 12,
                            }}
                          >
                            Quantity: {item.quantity}
                          </Typography>
                          <Typography
                            noWrap
                            variant="p"
                            style={{
                              maxWidth: 150,
                              color: "grey",
                              fontSize: 13,
                            }}
                          >
                            {item.color ? `Color: ${item.color}` : null}
                          </Typography>
                        </div>
                      </div>
                      <Typography variant="p">
                        Rs. {item.price}{" "}
                        <span style={{ color: "grey", fontSize: 13 }}>
                          X {item.quantity}
                        </span>
                      </Typography>
                    </div>
                  );
                })
              )
            ) : (
              <div></div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 30,
              }}
            >
              <Typography variant="p" style={{ color: "grey" }}>
                SubTotal ({totalQuantity} item's)
              </Typography>
              <Typography variant="h6">Rs. {subTotal}</Typography>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 16,
              }}
            >
              <Typography variant="p" style={{ color: "grey" }}>
                Shipping Fee
              </Typography>
              <Typography variant="h6">Rs. {shippingFee}</Typography>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 16,
              }}
            >
              <Typography variant="p" style={{ color: "grey" }}>
                Discount
              </Typography>
              <Typography variant="h6">Rs. {voucherDiscount}</Typography>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: 16,
              }}
            >
              <Typography variant="h6">Total</Typography>
              <Typography variant="h5" color="primary">
                Rs. {total}
              </Typography>
            </div>
          </div>
        </div>
      </Grid>
    );
  }

  const orderSummaryReceipt = () => {
    return (
      <Grid sm={12}>
        <div
          style={{
            margin: 0,
            marginTop: 20,
            marginRight: 0,
            border: "0.2px solid #e5e5e5",
          }}
        >
          <div className={classes.checkoutTitleBox} style={{ marginTop: 0 }}>
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                letterSpacing: 1,
                wordSpacing: 4,
              }}
            >
              ORDER SUMMARY
            </Typography>
          </div>

          <div className={classes.mainCheckoutBox}>
            {!checkoutProducts
              ? null
              : checkoutProducts.map((item) => {
                  return (
                    <div
                    className={classes.receiptSummaryBoxItem}
                      key={item._id}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          maxWidth: 300,
                        }}
                      >
                        {/* <img
                          className={classes.checkoutProductImg}
                          src={item.image}
                        ></img> */}
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Typography
                            noWrap
                            variant="p"
                            className={
                              classes.titleOfReceiptOrderSummaryProduct
                            }
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            noWrap
                            variant="p"
                            style={{
                              maxWidth: 150,
                              color: "grey",
                              fontSize: 12,
                            }}
                          >
                            Quantity: {item.quantity}
                          </Typography>
                          <Typography
                            noWrap
                            variant="p"
                            style={{
                              maxWidth: 150,
                              color: "grey",
                              fontSize: 13,
                            }}
                          >
                            {item.color ? `Color: ${item.color}` : null}
                          </Typography>
                        </div>
                      </div>
                      <Typography variant="p">
                        Rs. {item.price}{" "}
                        <span style={{ color: "grey", fontSize: 13 }}>
                          X {item.quantity}
                        </span>
                      </Typography>
                    </div>
                  );
                })}

            <div
              className={classes.receiptSummaryBoxItem}
            >
              <Typography variant="p" style={{ color: "grey" }}>
                SubTotal ({totalQuantity} item's)
              </Typography>
              <Typography variant="h6">Rs. {subTotal}</Typography>
            </div>

            <div
              className={classes.receiptSummaryBoxItem}
            >
              <Typography variant="p" style={{ color: "grey" }}>
                Shipping Fee
              </Typography>
              <Typography variant="h6">Rs. {shippingFee}</Typography>
            </div>

            <div
              className={classes.receiptSummaryBoxItem}
            >
              <Typography variant="p" style={{ color: "grey" }}>
                Discount
              </Typography>
              <Typography variant="h6">Rs. {voucherDiscount}</Typography>
            </div>

            <div
              style={{
                marginTop: 16,
                borderTop: "0.2px solid #e5e5e5",
              }}
              className={classes.receiptSummaryBoxItem}
            >
              <Typography variant="h6">Total</Typography>
              <Typography
                variant="h4"
                color="primary"
                style={{ fontWeight: "bold" }}
              >
                Rs. {total}
              </Typography>
            </div>
          </div>
        </div>

        <div style={{ paddingTop: 15, paddingBottom: 15 }}>
          <Typography variant="p">Expected delivery date</Typography>
          <Typography variant="h5" style={{ fontWeight: "bold" }}>
            {get7DaysAboveDate()}
          </Typography>
        </div>

        {/* <Divider
          style={{ marginBottom: 15, marginTop: 15, height: "0.5px" }}
        ></Divider> */}
        <div
          className={classes.receiptFooter}
        >
          <div>
            <Typography style={{ fontWeight: "bold" }}>
              Thanks for shopping
            </Typography>
            <Typography>Digi-Mart Team</Typography>
          </div>

          <div>
            <Typography style={{ fontWeight: "bold" }}>
              Need any Help ?
            </Typography>
            <Typography>Email at digimart.cui@gmail.com</Typography>
          </div>
        </div>
      </Grid>
    );
  };

  const getPaymentDetails = () => {
    return (
      <Grid container>
        <Grid lg={7} className={classes.StepperPage}>
          <Typography variant="h4">Select Payment Method</Typography>

          <div
            onClick={() => setSelectedPaymentMethod("cash")}
            className={classes.paymentMethodBox}
          >
            <Typography variant="h4">1. </Typography>
            <Radio
              checked={selectedPaymentMethod === "cash"}
              onChange={handleChangeSelectedPayment}
              value="cash"
              name="radio-button-cash"
              inputProps={{ "aria-label": "cash" }}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <MonetizationOnIcon
                fontSize="large"
                style={{ marginLeft: 15, marginRight: 10 }}
              />
              <Typography variant="h6">Cash On Delivery (Default)</Typography>
            </div>
          </div>

          <div
            onClick={() => setSelectedPaymentMethod("card")}
            className={classes.paymentMethodBox}
          >
            {/* <Radio
              checked={selectedPaymentMethod === "card"}
              onChange={handleChangeSelectedPayment}
              value="card"
              name="radio-button-card"
              inputProps={{ "aria-label": "card" }}
            /> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              {/* <CreditCardIcon
                fontSize="large"
                style={{ marginLeft: 15, marginRight: 10 }}
              /> */}
              <Typography variant="h4" style={{ marginRight: 10 }}>
                2.
              </Typography>
              <StripeCheckout
                stripeKey={STRIPE_KEY}
                token={handleStripeToken}
                // billingAddress = {address}
                // shippingAddress = {address}
                amount={Math.round(total) * 100}
                name={name}
                currency={"IDR"}
              />
            </div>
          </div>

          <Grid item xs={12} className={classes.buttons}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={handleBack}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={9}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handlePlaceOrder(null)}
                  fullWidth
                  disabled={selectedPaymentMethod === "card"}
                >
                  Confirm Order
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {orderSummaryBox("Payment")}
      </Grid>
    );
  };

  const orderConfirmationBox = () => {
    return (
      <Grid className={classes.orderConfirmationPage} id="orderConfirmation">
        <img className={classes.confirmationImage} src={confirm}></img>
        <Typography variant="h3" style={{ fontWeight: "bold", textAlign:'center' }}>
          Order Placed Successfully
        </Typography>
        <Typography
          variant="h5"
          style={{ paddingTop: 20, textAlign: "justify", color:'#666' }}
        >
          Congratulations! Your Order has been placed. You will soon recieve
          confirmation email.
        </Typography>
        <div className={classes.actionButtons}>
          <Button
            onClick={downloadReceipt}
            color="primary"
            className={classes.downloadReceiptBTn}
            style={{ marginRight: 15 }}
          >
            <GetAppIcon style={{ marginRight: 4 }} />
            Download Order Receipt
          </Button>
          <Button
            onClick={() =>
              window.open(paymentReceiptURL ? paymentReceiptURL : "#", "_blank")
            }
            color="primary"
            className={classes.downloadReceiptBTn}
            style={{
              marginRight: 15,
              display: paymentReceiptURL ? "flex" : "none",
            }}
          >
            <ReceiptIcon style={{ marginRight: 4 }} />
            View Payment Receipt
          </Button>
          <Link to="/" style={{ color: "white", textDecoration: "none" }}>
            <Button className={classes.continueShoppingBtn}>
              <LocalMallIcon style={{ marginRight: 4 }} />
              Continue Shopping
            </Button>
          </Link>
        </div>

        {/* Receipt download Box */}
        <Grid id="OrderReceiptBox" className={classes.receiptBox} sm={12}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <img className={classes.logo} src={logo}></img>
          </div>
          <Typography variant="h4" style={{ marginTop: 12, marginBottom: 13 }}>
            Your Order is Confirmed!
          </Typography>
          <Typography variant="p" gutterBottom>
            Hello {name ? name : null},
          </Typography>
          <Divider style={{ marginTop: 13, marginBottom: 13 }}></Divider>
          <div className={classes.receiptHeaderHeadings}>
            <div className={classes.headerOrderDetailsSingleBox}>
              <Typography variant="p" style={{ fontSize: 13 }}>
                Order Number
              </Typography>
              {orderResponse.map((order) => {
                return (
                  <div>
                    <Typography variant="p" style={{ color: "#666" }}>
                      {order.storeName + ":  "}
                    </Typography>
                    <Typography variant="p" style={{ fontWeight: "bold" }}>
                      {order ? order._id : null}
                    </Typography>
                  </div>
                );
              })}
            </div>

            <div className={classes.headerOrderDetailsSingleBox}>
              <Typography variant="p" style={{ fontSize: 13 }}>
                Order Date
              </Typography>
              <Typography variant="h6" style={{ fontWeight: "bold" }}>
                {new Date().toISOString().split("T")[0]}
              </Typography>
            </div>

            <div className={classes.headerOrderDetailsSingleBox}>
              <Typography variant="p" style={{ fontSize: 13 }}>
                Payment Method
              </Typography>
              <Typography variant="h6" style={{ fontWeight: "bold" }}>
                {selectedPaymentMethod}
              </Typography>
            </div>

            <div className={classes.headerOrderDetailsSingleBox}>
              <Typography variant="p" style={{ fontSize: 13 }}>
                Shipping City
              </Typography>
              <Typography variant="h6" style={{ fontWeight: "bold" }}>
                {orderResponse.length > 0
                  ? orderResponse[0].city
                  : city
                  ? city
                  : "Not Defined"}
              </Typography>
            </div>
          </div>

          {checkoutProducts.map((item, index) =>
            React.cloneElement(
              <div className={classes.CartItemBox}>
                <div className={classes.productDetailsBox}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* <img className={classes.itemImageBox} src={item.image} /> */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        paddingLeft: 9,
                      }}
                    >
                      <Typography
                        variant="h6"
                        className={classes.titleOfReceiptProduct}
                      >
                        {item.title}
                      </Typography>
                      <Typography variant="p" style={{ color: "black" }}>
                        Quantity: {item.quantity} pcs
                      </Typography>
                      <Typography variant="p" style={{ color: "#666" }}>
                        Store: {item.storeName}
                      </Typography>
                      <Typography
                        variant="p"
                        style={{ fontSize: 13, color: "#666" }}
                      >
                        Category: {item.category}
                      </Typography>
                      <Typography variant="p" style={{ color: "#666" }}>
                        Brand: {item.brand}
                        {item.color ? `, Color: ${item.color}` : null}
                        {item.dimensions
                          ? `, Dimensions: ${item.dimensions}`
                          : null}
                      </Typography>
                    </div>
                  </div>

                  {/* Price section */}
                  <div className={classes.priceSection}>
                    <Typography className={classes.priceText} variant="h5">
                      Rs. {item.price}
                    </Typography>
                    <Typography
                      variant="p"
                      style={{ fontSize: 13, color: "#666", marginTop: 4 }}
                    >
                      Shipping:{" "}
                      <span style={{ color: "black" }}>
                        {item.shippingCost ? `Rs. ${item.shippingCost}` : null}
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>,
              {
                key: item._id,
              }
            )
          )}

          {orderSummaryReceipt()}
          <Grid />
        </Grid>
      </Grid>
    );
  };

  const handleStripeToken = (stripeToken, addresses) => {
    const orderPaymentData = {
      token: stripeToken,
      order: {
        total: Math.round(total),
        name: name,
        address: {
          line1: "510 Townsend St",
          postal_code: "98140",
          city: "San Francisco",
          state: "CA",
          country: "US",
        },
      },
    };
    api
      .post(
        "/buyer/order/payment/card",
        {
          ...orderPaymentData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        // console.log("payment succcess", res.data.data);
        if (res.data.data.charge) {
          setSnackBar({
            ...snackBarstate,
            message: "Payment Successfull. Order Placed Successfully! ",
            type: "success",
            open: true,
          });
          setCardCharge(res.data.data.charge);
          console.log("charge", res.data.data.charge);
          handlePlaceOrder(res.data.data.charge);
        }
        // setOrderResponse(res.data.data.order);
      })
      .catch((error) =>
        error.response
          ? setSnackBar({
              ...snackBarstate,
              message: "Sorry! Your card is declined by stripe.",
              type: "error",
              open: true,
            })
          : null
      );
    // console.log("Stripe tokens", {stripeToken, addresses})
  };
  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 15 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} color="inherit" to="/">
            Home
          </Link>
          <Link className={classes.bCrumbLink} color="inherit" to="/cart">
            Cart
          </Link>
          <Typography color="textPrimary">Checkout</Typography>
        </Breadcrumbs>

        {/* Stepper Here */}
        <div className={classes.stepperroot}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              //   if (isStepOptional(index)) {
              //     labelProps.optional = (
              //       <Typography variant="caption">Optional</Typography>
              //     );
              //   }
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <div>
            {activeStep === steps.length ? (
              <div>
                <Typography className={classes.stepperinstructions}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Button onClick={handleReset} className={classes.stepperbutton}>
                  Reset
                </Button>
              </div>
            ) : (
              <div style={{ paddingBottom: 30 }}>
                <Grid>{getStepContent(activeStep)}</Grid>
                <div>
                  {/* <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.stepperbutton}
                  >
                    Back
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.stepperbutton}
                  >
                    {activeStep === steps.length - 1 ? "Finish" : "Next"}
                  </Button> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
